import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { InfoGroupComponent, ModalComponent } from '@tecalisdev/infinity';
import { UserAgentInfo } from '../../../core/utils/user-agent';

export interface DeviceUserAgentInput {
	user_agent: string;
	user_agent_info?: UserAgentInfo;
}

@Component({
	selector: 'app-modal-user-agent',
	standalone: true,
	imports: [TranslatePipe, ModalComponent, InfoGroupComponent],
	templateUrl: './modal-user-agent.component.html',
	styleUrl: './modal-user-agent.component.scss',
})
export class ModalUserAgentComponent {
	@Input() device?: DeviceUserAgentInput | null;
	@Output() closeEvent = new EventEmitter<void>();

	public closeModal(): void {
		this.closeEvent.emit();
	}
}
